<template>
  <div class="table-action-wrapper">
    <DatePicker :value="query.date.value" :preset-dates="presetDates" range multi-calendars placeholder="Date Range" class="date-picker-left" style="max-width: 250px" @change="changeDate" />
    <Select :options="statusOptions" placeholder="By Raw" data-title="By" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
    <Select v-if="$util.options.role != 'seller' || $util.options.role != 'designer'" source="user/search" type="auto" field="all" placeholder="Creator" :value="query.user_id.value" @changeValue="changeUserId"></Select>
    <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" :value="query.designer_id.value" @changeValue="changeDesignerId"></Select>
    <Select source="term/search" placeholder="Category" :value="query.term_id.value" @changeValue="changeTermId"></Select>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: {
          value: [],
          valueLabel: '',
          fieldLabel: 'Date Range'
        },
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        },
        designer_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Designer'
        },
        user_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Creator'
        },
        term_id: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Category'
        }
      },
      styles: [
        {
          text: 'text-warning',
          progressbar: 'bg-warning'
        },
        {
          text: 'text-danger',
          progressbar: 'bg-danger'
        },
        {
          text: 'text-primary',
          progressbar: 'bg-primary'
        },
        {
          text: 'text-success',
          progressbar: 'bg-success'
        }
      ],
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes
    },
    statusOptions() {
      return Object.values(Object.assign({}, this.extraAttributes?.status || {}))
    }
  },
  props: {
    config: Object
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.query.date = Object.assign(this.query.date, {
          value: null,
          valueLabel: ''
        })
      } else if (_.isArray(e)) {
        this.query.date = Object.assign(this.query.date, {
          value: e.map((item) => moment(item).format('YYYY-MM-DD')),
          valueLabel: e.map((item) => moment(item).format('YYYY/MM/DD')).join(' - ')
        })
      } else {
        return
      }
      this.$emit('change-filters', this.query)
    },
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeDesignerId(value, e) {
      this.query.designer_id = Object.assign(this.query.designer_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeUserId(value, e) {
      this.query.user_id = Object.assign(this.query.user_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeTermId(value, e) {
      this.query.term_id = Object.assign(this.query.term_id, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    submit() {
      this.$emit('change-filters', this.query)
    }
  }
}
</script>
